module.exports = "../../../../platform/assets/pageMainIcon/industry_yewushezhilei3.svg";